var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 914,
    height: 886,
    viewBox: "0 0 914 886",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_126_3838",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -209,
    y: -135,
    width: 999,
    height: 897
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 537.992,
    y: 885.325,
    width: 1046.16,
    height: 677.333,
    rx: 320,
    transform: "rotate(-146.326 537.992 885.325)",
    fill: "#F5F6F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_126_3838)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25.9999,
    y: -11,
    width: 850,
    height: 843,
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.455 390.079C292.827 389.45 292.199 388.822 291.571 388.508C290.629 387.88 290.315 388.508 290.315 389.45C290.315 392.906 290.315 396.047 290.315 399.502C287.489 399.188 287.175 396.989 286.861 395.105C285.919 384.738 283.721 374.686 280.266 364.635C279.638 363.064 279.638 361.493 280.58 360.237C283.721 358.038 279.952 355.525 280.894 353.326C289.059 364.635 290.629 377.514 293.455 390.079Z",
    fill: "#2C3926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.225 1148.69C93.433 1137.69 100.341 1127.01 102.853 1116.33C110.703 1083.35 118.239 1050.05 124.206 1016.44C126.09 980.318 135.196 944.822 138.336 909.011C140.848 881.054 143.988 853.097 145.558 824.826C146.186 813.204 146.814 801.267 147.128 789.644C147.128 788.702 147.442 787.76 147.756 786.817C149.64 777.079 148.384 767.027 148.698 757.29C149.012 747.238 149.954 746.295 160.316 746.923C168.48 747.552 176.331 748.18 184.495 749.122C185.437 749.122 186.379 749.436 187.007 749.751C190.461 751.007 193.915 750.693 197.369 750.693C218.407 751.635 239.446 753.834 260.17 755.719C267.078 756.347 269.904 753.834 272.102 747.866C274.928 739.384 277.44 730.903 279.01 722.422C279.638 718.966 279.952 715.825 282.778 713.312C285.918 711.742 289.059 711.742 291.885 714.255C294.711 717.396 294.083 720.851 293.455 724.621C280.266 788.702 264.88 852.469 245.098 914.98C243.842 918.435 243.214 922.205 242.272 925.66C232.852 950.79 225.315 976.548 215.895 1001.99C214.325 1006.39 212.441 1010.79 209.301 1014.24C199.881 1038.12 190.775 1062.3 181.041 1085.86C173.504 1104.08 165.34 1121.99 157.804 1140.52C155.606 1146.49 149.64 1143.03 146.814 1146.18C138.65 1147.75 130.8 1146.8 122.636 1146.8C115.099 1146.49 108.505 1146.17 102.225 1148.69Z",
    fill: "#C5CED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.073 925.974C240.073 914.98 245.097 905.242 248.238 895.19C263.938 841.161 278.068 786.503 288.744 730.903C289.686 725.877 293.454 720.851 290.314 715.197C298.164 711.113 306.015 712.998 313.551 716.139C317.633 722.108 318.261 729.333 319.831 736.243C325.483 760.431 329.565 784.932 333.647 809.434C333.961 812.261 334.903 815.088 332.705 817.601C334.903 836.449 337.101 855.296 338.985 874.144C340.555 889.536 342.439 905.242 343.381 920.634C344.637 947.02 347.463 973.721 346.835 1000.11C346.835 1004.19 347.777 1008.27 348.405 1012.36C348.405 1051.94 348.405 1091.83 348.405 1131.41C348.405 1136.12 349.661 1141.78 342.125 1141.78C340.555 1141.78 340.869 1144.29 340.555 1145.86C327.053 1141.46 313.237 1143.35 299.734 1144.29C291.884 1140.52 290.628 1132.98 288.744 1125.76C279.638 1088.06 269.904 1050.05 260.484 1012.36C258.286 1010.16 257.658 1007.65 256.716 1004.82C250.75 981.26 245.411 957.387 239.445 933.827C238.503 930.686 238.817 928.173 240.073 925.974Z",
    fill: "#AFB8C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.432 540.858C163.77 534.261 168.795 527.665 174.447 521.068C176.959 518.241 176.331 517.299 173.505 515.1C155.92 500.964 149.954 475.834 159.688 455.73C161.258 452.589 158.118 447.877 163.142 446.307C165.34 446.935 167.853 447.249 170.051 446.307C180.727 442.851 191.403 445.05 201.451 448.191C210.243 451.019 219.036 453.532 227.828 455.73C234.422 456.987 241.33 456.987 247.924 458.243C253.89 459.186 260.17 459.5 262.054 467.039C272.417 516.042 280.267 565.674 284.663 615.62C287.175 643.577 288.745 671.219 285.919 699.176C285.291 704.202 284.349 708.914 281.837 713.312C279.639 725.877 277.441 738.442 272.416 750.379C270.218 756.033 268.334 758.86 260.798 757.604C239.132 754.776 217.465 753.834 195.485 752.263C192.659 750.379 188.891 752.578 186.065 750.693C184.181 749.75 182.611 748.18 181.983 746.295C174.133 724.935 170.993 702.946 171.621 680.957C163.456 699.491 153.722 718.338 144.302 737.5C142.732 740.641 141.162 744.096 137.708 745.981C130.8 758.546 123.578 771.111 115.728 783.048C113.844 785.561 111.96 787.759 109.447 789.958C101.597 790.587 93.7472 788.702 85.897 788.074C85.269 787.759 84.641 786.817 84.013 786.817C76.4769 787.445 75.5348 784.932 76.1629 777.079C77.4189 760.745 78.9889 744.724 81.501 728.704C82.443 721.793 83.699 714.883 84.641 707.972C84.641 693.208 89.6651 679.387 93.7472 665.565C105.679 625.357 123.892 587.663 146.814 552.795C150.268 549.025 153.722 544.628 158.432 540.858Z",
    fill: "#FDFAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.432 540.858C130.8 578.867 109.761 620.332 96.259 665.565C91.8629 680.015 88.4088 694.465 84.6408 708.914C81.5007 699.491 82.4427 689.753 83.3847 680.329C84.9548 662.738 87.4668 645.461 93.7469 628.499C103.481 603.055 117.297 580.438 136.138 560.962C137.394 559.706 138.336 558.135 139.592 556.878C146.814 552.481 150.268 543.685 158.432 540.858Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.464 713.94C283.092 706.087 283.72 698.234 284.348 690.695C287.174 652.372 283.092 614.363 278.696 576.354C274.3 539.602 267.078 503.477 260.798 467.353C264.88 466.411 268.334 467.667 271.474 470.494C280.58 475.52 279.324 483.688 279.324 492.169C278.382 533.005 290.628 571.014 305.072 608.395C314.493 633.21 325.169 657.712 331.135 683.784C333.019 691.323 334.589 699.176 334.589 707.03C334.589 716.453 332.077 718.652 322.657 717.396C319.831 717.082 317.005 717.082 314.179 717.082C306.328 715.825 298.478 715.197 290.628 715.197C287.802 713.626 285.29 713.94 282.464 713.94Z",
    fill: "#008C15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.022 746.61C149.326 723.993 160.316 701.376 171.62 678.759C174.76 703.575 176.016 728.39 186.693 751.321C176.644 750.379 166.596 750.065 156.548 748.808C151.838 748.18 150.268 749.123 150.582 753.834C150.582 762.63 150.582 771.425 150.582 780.221C150.582 782.734 151.21 785.561 149.012 787.446C144.302 779.593 147.128 770.797 146.5 762.316C146.186 756.976 146.5 751.95 142.418 747.866C141.476 746.61 139.906 746.924 138.022 746.61Z",
    fill: "#E3E0DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.828 457.93C217.151 455.102 206.161 451.961 195.485 449.134C186.065 446.621 176.645 445.993 167.852 450.391C162.828 452.904 163.456 449.762 163.456 446.935C166.282 437.511 170.992 429.344 177.587 422.119C186.693 412.067 190.775 400.445 190.461 386.938C190.147 380.969 190.775 375.001 192.031 369.032C195.485 350.499 210.871 336.364 230.968 332.908C251.378 329.139 271.16 337.306 281.208 353.64C281.522 356.153 285.605 358.352 281.522 361.179C279.638 361.808 278.068 362.122 276.812 363.692C267.706 375.315 254.204 379.713 241.958 386.623C238.818 388.508 235.678 388.194 232.224 387.88C227.514 387.566 223.117 388.194 221.547 393.534C219.977 398.56 221.547 403.272 226.257 405.471C231.282 407.984 233.166 412.067 233.794 417.093C235.364 429.03 234.736 440.967 234.422 452.904C234.108 456.987 232.538 459.814 227.828 457.93Z",
    fill: "#091E0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.474 470.495C267.706 470.495 263.938 469.238 260.798 467.353C259.228 459.814 252.32 462.641 247.924 460.757C241.958 455.417 242.586 448.192 242.272 441.281C242.272 437.197 246.04 437.512 248.866 438.454C253.89 439.71 258.6 442.223 263.624 443.48C277.754 447.249 282.464 444.736 285.918 430.287C288.116 420.235 288.744 409.869 288.43 399.188C288.744 395.733 288.116 392.592 289.372 389.136C289.686 387.88 290.314 386.623 291.884 386.938C293.14 387.252 293.14 389.136 293.768 390.079C299.421 411.753 303.503 434.056 303.189 456.673C302.875 468.924 301.619 469.866 289.686 470.18C283.406 470.495 277.44 470.495 271.474 470.495Z",
    fill: "#0A1F0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.58 360.551C286.546 372.802 287.802 386.623 290 399.817C290 412.067 290.314 424.318 286.232 436.255C282.778 446.621 278.696 448.506 268.02 446.935C259.542 445.679 252.319 441.595 243.527 438.454C243.841 446.621 245.097 453.846 247.609 460.757C241.015 459.814 234.107 458.872 227.513 457.93C230.653 457.615 231.909 456.359 231.909 452.904C232.223 439.71 232.537 426.203 230.653 413.01C230.339 409.554 228.455 408.926 225.943 407.984C218.407 404.843 215.581 399.188 218.093 392.278C220.605 385.367 226.257 384.11 232.851 385.367C234.735 385.681 236.305 387.252 238.189 385.995C251.063 377.514 267.706 374.373 276.184 359.609C278.696 355.839 279.324 359.923 280.58 360.551Z",
    fill: "#CAAA8F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.464,
    y: 322,
    width: 79.0716,
    height: 96.9409,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.464,
    y: 441.061,
    width: 79.0716,
    height: 96.9409,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 561,
    width: 79.0716,
    height: 96.9409,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.928,
    y: 441.061,
    width: 79.0716,
    height: 96.9409,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.464,
    y: 561,
    width: 79.0716,
    height: 96.9409,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.928,
    y: 561,
    width: 79.0716,
    height: 96.9409,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454,
    y: 322,
    width: 79.0716,
    height: 96.9409,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454,
    y: 441.061,
    width: 79.0716,
    height: 96.9409,
    rx: 8,
    fill: "#008C15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.113 468L498.078 483.28L514.144 483.28L501.146 492.723L506.111 508.003L493.113 498.56L480.115 508.003L485.08 492.723L472.082 483.28L488.149 483.28L493.113 468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454,
    y: 561,
    width: 79.0716,
    height: 96.9409,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596 348.357L600.965 363.637L617.031 363.637L604.033 373.081L608.998 388.361L596 378.917L583.002 388.361L587.967 373.081L574.969 363.637L591.035 363.637L596 348.357Z",
    fill: "#008C15"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/LoginBackground.0aeefda7c3f27fd569c191bdb3e1df61.svg";
export { ForwardRef as ReactComponent };